const ChevronLeft = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="40"
		height="40"
		fill="none"
		viewBox="0 0 14.4 23.7"
	>
		<path stroke="currentColor" strokeWidth="3" d="M11.19,1.81l-9.12,10,9.12,10" />
	</svg>
);

const ChevronRight = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="40"
		height="40"
		fill="none"
		viewBox="0 0 14.4 23.7"
	>
		<path stroke="currentColor" strokeWidth="3" d="M2.1,21.9l9.1-10l-9.1-10" />
	</svg>
);

export { ChevronLeft, ChevronRight };
